import styled from '@emotion/styled';
import { MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';

export const DayOfContainer = styled.div<{
  isPostAuthNav3?: boolean;
}>`
  ${MEDIA_QUERY.DESKTOP} {
    margin-left: ${({ isPostAuthNav3 }) => (isPostAuthNav3 ? '74px' : 0)};
  }
`;
